<template>
  <div>
    <b-container v-if="serveEventList.length > 0" class="bv-example-row">
      <b-row>
        <b-col cols="12">
          <b-button-group>
            <b-button @click="showList = true" :active="showList"
              ><i class="fa fa-list"></i
            ></b-button>
            <b-button @click="showList = false"
              ><i class="fa fa-calendar"></i
            ></b-button>
          </b-button-group>
        </b-col>
      </b-row>
      <br />
      <b-row v-if="showList">
        <b-col cols="12">
          <b-table
            :items="serveEventList"
            :fields="tableEventConfig.fields"
            responsive="sm"
            sort-by="When"
          >
          </b-table>
          <b-button
            @click="isModalAddNewEvent = true"
            variant="outline-secondary"
            class="fa fa-plus button-add"
          >
          </b-button>
          <b-modal v-model="isModalAddNewEvent" size="lg" :hide-footer="true">
            <b-form @submit.prevent="ok">
              <b-row>
                <b-col>
                  <label for="event-title">Event Name</label>
                  <b-input v-model="text" id="event-title" name="text" />
                </b-col>
                <b-col>
                  <label for="connection">Connections</label>
                  <b-input v-model="subText" id="last-name" name="last-name" />
                </b-col>
              </b-row>
              <b-button
                size="sm"
                variant="danger"
                @click="isModalAddNewEvent = false"
              >
                Cancel
              </b-button>
              <b-button
                type="submit"
                size="sm"
                variant="success"
                @click="isModalAddEvent"
              >
                Save
              </b-button>
            </b-form>
            <!-- <template v-slot:modal-footer="{ cancel }">
                        </template> -->
          </b-modal>
        </b-col>
      </b-row>

      <b-row class="card" v-else>
        <div class="card-body">
          <a-calendar>
            <ul class="events" slot="dateCellRender" slot-scope="value">
              <!-- {{value}} -->
              <li v-for="item in getListData(value)" :key="item.key">
                <div class="item-per-day">
                  <div>DOT {{ item.content }} ...</div>
                  <div class="at-calendar">at ({{ item.at }})</div>
                </div>
                <!-- <a-badge :status="item.type" :text="item.content" class="item-per-day" /> -->
              </li>
            </ul>
            <template slot="monthCellRender" slot-scope="value">
              <div v-if="getMonthData(value)" class="notes-month">
                <section>{{ getMonthData(value) }}</section>
                <span>Events this month</span>
              </div>
            </template>
          </a-calendar>
        </div>
      </b-row>
    </b-container>
    <template v-else>
      <b-card>
        <b-media no-body>
          <b-media-aside vertical-align="center">
            <b-img
              src="/trainempty.png"
              width="100%"
              height="100%"
              alt="No Focus"
            ></b-img>
          </b-media-aside>
          <b-media-body class="ml-3">
            <h2 class="mt-0">There are Events in Your Future</h2>
            <h4>
              I know this because you are a go-getter who will create a focused
              journey soon.
            </h4>
          </b-media-body>
        </b-media>
      </b-card>
    </template>
  </div>
</template>
<script>
import moment from "moment";

export default {
  components: {},
  beforeCreate() {},
  methods: {
    handleEditNameClick() {
      this.isEditingName = !this.isEditingName;
    },
    handleFilterFocus(e) {
      console.log(e, "where to handle filter focus");
    },
    handleAddFocusBtnClick: function() {
      console.log("triggered add button");
    },
    isModalAddEvent() {
      // dispatch
      this.isModalAddNewEvent = false;
    },
    getListData(value) {
      let strVal = JSON.stringify(moment(value).format("DD-MM-YYYY"));
      let listData = [];
      let events = [...this.$store.getters["user/listEvents"]]; //, ...this.$store.getters['user/userSessions'], ...this.$store.getters['user/guideSessions']]
      let dayEvents = events.filter(
        el =>
          JSON.stringify(
            moment(this.cD(el)._start_at.toDate()).format("DD-MM-YYYY")
          ) === strVal
      );

      dayEvents &&
        dayEvents.forEach((el, index) => {
          let data = {
            type: "default",
            content: el.engine ? el.engine : el.session && "Focus Session",
            key: `${el.engine ? el.engine : el.session.id}__${index}`,
            at: `${moment(new Date(this.cD(el)._start_at.toDate())).format(
              "hh:mm A"
            )} to ${moment(new Date(this.cD(el)._end_at.toDate())).format(
              "hh:mm A"
            )}`
          };
          listData.push(data);
        });
      return listData || [];
    },
    cD(el) {
      if (el.session) {
        el._start_at = el._booked_at;
        el._end_at = el._booked_at;
      }
      return el;
    },
    getMonthData(value) {
      debugger;
      let strVal = JSON.stringify(moment(value).format("MM-YYYY"));
      // let listData = []
      let events = [...this.$store.getters["user/listEvents"]]; //, ...this.$store.getters['user/userSessions'], ...this.$store.getters['user/guideSessions']]
      let monthEvents = events.filter(
        el =>
          JSON.stringify(
            moment(this.cD(el)._start_at.toDate()).format("MM-YYYY")
          ) === strVal
      );
      // monthEvents && monthEvents.forEach((el,index) => {
      //     let data = {type: "default", content: el.engine, key: `${el.engine}__${index}`, monthlyAmountEvents:}
      //     listData.push(data)
      // })

      return monthEvents.length || null;
    }
  },
  computed: {
    serveEventList() {
      let tableData = [...this.$store.getters["user/listEvents"]]; //, ...this.$store.getters['user/userSessions'], ...this.$store.getters['user/guideSessions']]
      return tableData.map(el => {
        return {
          Event: el.engine ? el.engine : el.session ? "Focus Session" : null,
          When: el._start_at
            ? el._start_at
            : el._booked_at
            ? el._booked_at
            : null,
          at: el.engine
            ? `${moment(new Date(el._start_at.toDate())).format(
                "hh:mm A"
              )} to ${moment(new Date(el._end_at.toDate())).format("hh:mm A")}`
            : `${moment(new Date(el._booked_at.toDate())).format("hh:mm A")}`,
          "<P>lace": el.place ? el.place : null
        };
      });
    }
  },
  data() {
    return {
      // FIELD FOR ADD NAMES
      text: "",
      subText: "",
      notes: "",
      tableEventConfig: {
        fields: [
          { key: "Event", sortable: true },
          {
            key: "When",
            sortable: true,
            formatter: value => {
              return moment(new Date(value.toDate())).format(
                "dddd, DD MMMM YYYY"
              );
            }
          },
          { key: "at", sortable: true },
          { key: "<P>lace", sortable: true }
        ]
        // sortBy: 'Event',
        // sortDesc: false
      },
      isModalAddNewEvent: false,
      showList: false
    };
  },
  mounted() {
    this.$store.dispatch("user/getListEvents");
    // this.$store.dispatch("user/getListUserSessions")
    //this.$store.dispatch("user/getListGuideSessions")
  }
};
</script>
<style lang="scss" module>
@import "./style.module.scss";
</style>
<style>
.button-add {
  width: 100%;
  background-color: #575757;
  color: white;
}
.item-per-day {
  font-size: 11px;
  margin-bottom: 5px;
}
.at-calendar {
  font-weight: bold;
}

.ant-fullcalendar-content::-webkit-scrollbar {
  width: 2px;
  height: 6px;
}
.ant-fullcalendar-content::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-border-radius: 6px;
  border-radius: 6px;
}
.ant-fullcalendar-content::-webkit-scrollbar-thumb {
  -webkit-border-radius: 6px;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
}
.ant-fullcalendar-content::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(0, 0, 0, 0.3);
}
</style>
